export default "__VITE_ASSET__uBrgn6nz__"